import { combineReducers } from "redux";
import metaDataReducer from "./metaDataReducer";

const rootReducers = combineReducers({
  metaDataReducer,
});

export default rootReducers;
